import React, { useState, useEffect} from 'react'
import { useSelector } from 'react-redux';
import { selectCart, selectShipping } from '../../slice/itemSlice';
import { Button, Form } from 'react-bootstrap';

const Payment = () => {

  const cart = useSelector(selectCart)
  const [cartTotal, setCartTotal] = useState(0);
  const [total, setTotal] = useState(0);
  let method = useSelector(selectShipping)

  useEffect(() => {
    let result = 0;
    cart.map(i => result += (i.price*i.quantity))
    setCartTotal(result)
    if(method === "standard"){
      result += 1
    } else if(method === "express"){
      result += 3
    }
    setTotal(result)
  }, [cart, method])


  return (
    <div style={{background:"rgba(0,0,0,0.05)"}} className='w-100 p-2 h-100 text-dark d-flex p-4 flex-column align-content-between'>
      <h2 className='display-6'>
        Payment
      </h2>
      <div className=' mt-4 border-dark border-bottom'>
        <div className='d-flex fs-4 justify-content-between'><p>Items Total </p><p>{cartTotal}</p></div>
        <div className='d-flex fs-4 justify-content-between'><p>Shipping Cost </p><p>{method==="standard"?1:method==="express"?3:0}</p></div>
      </div>
      <div className='mt-4 d-flex fs-2 justify-content-between'>
        <p>Total</p>
        <p>{total} <span className='text-info'>$</span></p>
      </div>
      <Form onSubmit={(e) => console.log(e)}>
        <Form.Group className="mt-4" controlId="formDiscount">
          <Form.Label>Enter Discount Code</Form.Label>
          <Form.Control className='py-2 px-3 fs-5' onChange={(e) => console.log(e.target.value)} required type="name" placeholder="" />
        </Form.Group>
      </Form>
      <Button className='mt-4 w-100 p-2 fs-3' variant="outline-dark">Purchase</Button>
    
    </div>
  )
}

export default Payment